import React from 'react';

//CORE COMPONENTS
import { ThemeProvider, styled } from '../../../../../components-core/packages/components-core/dist/theme-provider/index';
import { Text, TextAppearance, TextAlignment, TextColor, strikethrough } from '../../../../../components-core/packages/components-core/dist/text';
import { Image } from '../../../../../components-core/packages/components-core/dist/image/index';

//BUTTON
import { ActionButton } from '../../../../../components-core/packages/components-core/dist/action-button';

//LAYOUT
import {
    Container,
    ContainerWrap,
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment,
    ContainerVerticalAlignment
} from '../../../../../components-core/packages/components-core/dist/container/index';
import { Breakpoints } from '../../../../../components-core/packages/components-core/dist/helpers';

//LAYERS
import { LayerWrapper } from '../../../../../components-core/packages/components-core/dist/layer-wrapper';
import { ContentLayer } from '../../../../../components-core/packages/components-core/dist/content-layer';
import { ShimLayer } from '../../../../../components-core/packages/components-core/dist/shim-layer';

//ICONS CORE
import { ChevronDown } from '../../../../../components-core/packages/icons-core/dist/ChevronDown';
import { Close } from '../../../../../components-core/packages/icons-core/dist/Close'
import AccordionContentRows from '../accordion-content-row/AccordionContentRow';
import trendlineImage from '../../inner-components/price-table/caddy-trendline.png'
import exclusiveImage from '../../inner-components/price-table/caddy-exclusive.png'
import maxiVanImage from '../../inner-components/price-table/caddy-maxivan.png'
import comfortlineImage from '../../inner-components/price-table/caddy-comfortline.png'
import trCityVan from '../../inner-components/price-table/tr-cityvan.png'
import trPanelVan from '../../inner-components/price-table/tr-panelvan.png'
import trPikap from '../../inner-components/price-table/tr-pikap.png'
import careComfortline from '../../inner-components/price-table/cara-comfortline.png'
import careHighline from '../../inner-components/price-table/care-highline.png'
import amarokHighline from '../../inner-components/price-table/amarok-highline.png'
import amarokAventura from '../../inner-components/price-table/amarok-aventura.png'
import amarokCanyon from '../../inner-components/price-table/amarok-canyon.png'
import crafterOkul from '../../inner-components/price-table/crafter-okul.png'
import crafterServis from '../../inner-components/price-table/crafter-servis.png'
import crafterPanelVan from '../../inner-components/price-table/crafter-panelvan.png'
import { CTA } from '../../../../../components-core/packages/components-core/dist/call-to-action';
const BorderContainer = styled.div`
    border: 1px solid #dfe4e8;
`;

const ColorContainer = styled.div`
    background-color: ${props => props.isColor};
    margin-bottom: 1%;
`;


const Line = styled.div`
    background-color: #dfe4e8;
    width: 100%;
    height: 2px;
    display: ${props => props.isLast ? 'none' : 'block'};
`;

const PopUpContainer = styled.div`
    position:revert;
`;


class PriceCard extends React.Component {

    constructor() {
        super();
        this.state = {
            isContentLayerVisible: false,
            isSecondContentLayerVisible: false,
            isThreeContentLayerVisible: false,
            isPopUpActionButtonVisible: true,
        }
    }


    renderColorSection(carName, colorContainer) {
        return (
            <ThemeProvider theme={'image'}>
                <ColorContainer isColor={colorContainer}>
                    <Container stretchContent={true} padding={colorContainerPadding}>
                        <Text appearance={TextAppearance.headline0250} bold>{carName}</Text>
                    </Container>
                </ColorContainer>
            </ThemeProvider>
        )
    }

    renderImageSection(carImage) {
        if (carImage === 1) {
            return (
                <div style={{ marginTop: '-40px' }}>
                    <Container stretchContent={true} padding={imageContainerPadding} >
                        <Image src={trendlineImage} />
                    </Container>
                </div>
            )
        }
        else if (carImage === 2) {
            return (
                <div style={{ marginTop: '-40px' }}>
                    <Container stretchContent={true} padding={imageContainerPadding}>
                        <Image src={comfortlineImage}  />
                    </Container>
                </div>
            )
        }
        else if (carImage === 3) {
            return (
                <div style={{ marginTop: '-40px' }}>
                    <Container stretchContent={true} padding={imageContainerPadding} >
                        <Image src={exclusiveImage} />
                    </Container></div>
            )
        } else if (carImage === 4) {
            return (
                <div style={{ marginTop: '-40px' }}>
                    <Container stretchContent={true} padding={imageContainerPadding} >
                        <Image src={maxiVanImage} />
                    </Container></div>
            )
        }
        else if (carImage === 5) {
            return (
                <div style={{ marginTop: '-40px' }}>
                    <Container stretchContent={true} padding={imageContainerPadding} >
                        <Image src={trCityVan} />
                    </Container></div>
            )
        }
        else if (carImage === 6) {
            return (
                <div style={{ marginTop: '-40px' }}>
                    <Container stretchContent={true} padding={imageContainerPadding} >
                        <Image src={trPanelVan} />
                    </Container></div>
            )
        }
        else if (carImage === 7) {
            return (
                <div style={{ marginTop: '-40px' }}>
                    <Container stretchContent={true} padding={imageContainerPadding} >
                        <Image src={trPikap} />
                    </Container></div>
            )
        }
        else if (carImage === 8) {
            return (
                <div style={{ marginTop: '-40px' }}>
                    <Container stretchContent={true} padding={imageContainerPadding} >
                        <Image src={careComfortline} />
                    </Container></div>
            )
        }
        else if (carImage === 9) {
            return (
                <div style={{ marginTop: '-40px' }}>
                    <Container stretchContent={true} padding={imageContainerPadding} >
                        <Image src={careHighline} />
                    </Container></div>
            )
        }
        else if (carImage === 10) {
            return (
                <div style={{ marginTop: '-40px' }}>
                    <Container stretchContent={true} padding={imageContainerPadding} >
                        <Image src={amarokHighline} />
                    </Container></div>
            )
        }
        else if (carImage === 11) {
            return (
                <div style={{ marginTop: '-40px' }}>
                    <Container stretchContent={true} padding={imageContainerPadding} >
                        <Image src={amarokCanyon}  />
                    </Container></div>
            )
        }
        else if (carImage === 12) {
            return (
                <div style={{ marginTop: '-40px' }}>
                    <Container stretchContent={true} padding={imageContainerPadding} >
                        <Image src={amarokAventura} />
                    </Container></div>
            )
        }
        else if (carImage === 13) {
            return (
                <div style={{ marginTop: '-40px' }}>
                    <Container stretchContent={true} padding={imageContainerPadding} >
                        <Image src={crafterServis} />
                    </Container></div>
            )
        }
        else if (carImage === 14) {
            return (
                <div style={{ marginTop: '-40px' }}>
                    <Container stretchContent={true} padding={imageContainerPadding} >
                        <Image src={crafterOkul} />
                    </Container></div>
            )
        }
        else if (carImage === 15) {
            return (
                <div style={{ marginTop: '-40px' }}>
                    <Container stretchContent={true} padding={imageContainerPadding} >
                        <Image src={crafterPanelVan} />
                    </Container></div>
            )
        }

    }

    renderDetailSection(modelName, modelPrice) {
        return (
            <Container padding={detailContainerPadding} wrap={ContainerWrap.always} gutter={ContainerGutter.dynamic0100}>
                <Text appearance={TextAppearance.copy0200} bold>{modelName} </Text>
                <Container
                    horizontalAlign={ContainerHorizontalAlignment.spaceBetween}
                    verticalAlign={ContainerVerticalAlignment.flexEnd}
                    wrap={ContainerWrap.never}
                >
                    {/** TODO: @SerifhanIsıklı Otomatik olarak aşağı atmalı yap */}
                    <Container wrap={ContainerWrap.always}>
                        <Text appearance={TextAppearance.copy0150}>Kampanyalı anahtar</Text>
                        <Text appearance={TextAppearance.copy0150}>teslim fiyatı</Text>
                    </Container>
                    <Text textAppearance={TextAppearance.copy0200} bold ><span style={{ color: '#00b0f0' }}>{modelPrice} TL</span></Text>
                </Container>
            </Container>
        )
        //TODO: @SerifhanIsıklo birden fazla opsiyon olduğunda aralarında çizgiler çıkmalı.
    }

    renderPopupButton() {
        if (this.state.isPopUpActionButtonVisible) {
            return (

                <Container gutter={ContainerGutter.dynamic0050}
                    horizontalAlign={ContainerHorizontalAlignment.center}
                    padding={{ top: ContainerPadding.dynamic0100, bottom: ContainerPadding.dynamic0100 }}
                >
                    <a

                        tag="button"
                        emphasis="secondary"
                        onClick={() => this.setState({ isContentLayerVisible: !this.state.isContentLayerVisible, isPopUpActionButtonVisible: false })}
                    >
                        <span style={{ color: '001e50' }}>Fiyat Detayı</span>
                    </a><ChevronDown variant={'small'} />
                </Container>
            )
        }

    }

    renderContentFeatures(dataCarFeatures) {
        const data = dataCarFeatures;

        return data.map((row, index) =>
            <Container
                wrap={ContainerWrap.always}
                stretchContent={true}
                verticalAlign={ContainerVerticalAlignment.center}
            >
                <Container
                    horizontalAlign={ContainerHorizontalAlignment.spaceBetween}
                    verticalAlign={ContainerVerticalAlignment.center}
                    wrap={ContainerWrap.never}
                >
                    <Container wrap={ContainerWrap.always} padding={ContainerPadding.static200}>
                        {this.renderContentLength(row.title)}
                    </Container>
                    <Container horizontalAlign={ContainerHorizontalAlignment.flexEnd} wrap={ContainerWrap.always} padding={ContainerPadding.static200}>
                        <Text
                            appearance={TextAppearance.copy0200}
                            textAlign={TextAlignment.right}
                        >
                            {this.renderDescription(row.title, row.description)}
                        </Text>
                    </Container>
                </Container>

                <Container
                    stretchContent={true}
                    padding={{ top: ContainerPadding.static200, bottom: index !== data.length - 1 && ContainerPadding.static200 }}
                >
                    <Line isLast={index === data.length - 1} />
                </Container>
            </Container>
        )
    }
    renderDescription(title, description) {
        if (title == "Anahtar Teslim Fiyatı") {
            return (
                <Text
                    appearance={TextAppearance.copy0200}
                    textAlign={TextAlignment.right}
                    strikethrough
                >
                    {description}
                </Text>
            )
        } else {
            return (<Text
                appearance={TextAppearance.copy0200}
                textAlign={TextAlignment.right}
            >
                {description}
            </Text>)

        }

    }
    renderContentLength(title) {
        const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;
        const value = title.split(' ');
        if (value.length == 4 && isMobile) {
            return (
                <Text appearance={TextAppearance.copy0200}>
                    {value[0] + ' ' + value[1]}<br />
                    {value[2] + ' ' + value[3]}
                </Text>
            )
        }
        else {
            return (<Text appearance={TextAppearance.copy0200} >
                {title}
            </Text>)
        }
    }

    renderContentLayer(data, modelName, modelPrice) {
        const { isContentLayerVisible } = this.state;
        const changeIsContentLayerVisible = () => this.setState({ isContentLayerVisible: !isContentLayerVisible })

        return (
            <PopUpContainer>

                <LayerWrapper>
                    {
                        isContentLayerVisible ? [
                            <ShimLayer key="shim" onClick={() => changeIsContentLayerVisible()} />,
                            <ContentLayer
                                key="content-layer"
                                active={isContentLayerVisible}
                                ariaLabelledBy="headline-id"
                                onEscKeyUp={() => this.setState({ isContentLayerVisible: !this.state.isContentLayerVisible })}
                            >
                                <PopUpContainer>
                                    <Container
                                        padding={ContainerPadding.static200}
                                        wrap={ContainerWrap.always}
                                        stretchContent={true}
                                        verticalAlign={ContainerVerticalAlignment.center}
                                    >
                                        <Container
                                            horizontalAlign={ContainerHorizontalAlignment.spaceBetween}
                                            verticalAlign={ContainerVerticalAlignment.center}
                                            wrap={ContainerWrap.never}
                                        >
                                            <Container wrap={ContainerWrap.always}>
                                                <Text></Text>
                                            </Container>
                                            <Container horizontalAlign={ContainerHorizontalAlignment.flexEnd} wrap={ContainerWrap.never}>
                                                <CTA
                                                    tag="button"
                                                    emphasis="secondary"
                                                    ariaLabel="aria label"
                                                    size="small"
                                                    icon={<Close variant={'small'} />}
                                                    onClick={() => this.setState({ isContentLayerVisible: !this.state.isContentLayerVisible, isPopUpActionButtonVisible: !this.state.isPopUpActionButtonVisible })} />

                                            </Container>
                                        </Container><br />
                                        <Container wrap={ContainerWrap.always}>
                                            <Text appearance={TextAppearance.copy0200} bold>
                                                {modelName}<br />
                                                <span style={{ color: '#00b0f0' }}>{modelPrice} TL</span>
                                            </Text>
                                        </Container>
                                    </Container>
                                    <Container stretchContent={true} wrap={ContainerWrap.always}
                                    >
                                        {this.renderContentFeatures(data)}
                                    </Container>
                                    <Container
                                        horizontalAlign={ContainerHorizontalAlignment.center}
                                        padding={{ top: ContainerPadding.dynamic0100, bottom: ContainerPadding.dynamic0100 }}
                                    >
                                        <ActionButton
                                            icon={<Close variant={'small'} />}
                                            onClick={() => this.setState({ isContentLayerVisible: !this.state.isContentLayerVisible, isPopUpActionButtonVisible: !this.state.isPopUpActionButtonVisible })}
                                        >
                                            Kapat
                </ActionButton>
                                    </Container>
                                </PopUpContainer>
                            </ContentLayer>

                        ]
                            : undefined
                    }
                </LayerWrapper>
            </PopUpContainer>
        )
    }

    renderSecondContentLayer(data, modelName, modelPrice) {
        const { isSecondContentLayerVisible } = this.state;
        const changeIsContentLayerVisible = () => this.setState({ isSecondContentLayerVisible: !isSecondContentLayerVisible })

        return (
            <LayerWrapper>
                {
                    isSecondContentLayerVisible ? [
                        <ShimLayer key="shim" onClick={() => changeIsContentLayerVisible()} />,
                        <ContentLayer
                            key="content-layer"
                            active={isSecondContentLayerVisible}
                            wrap={ContainerWrap}
                            ariaLabelledBy="headline-id"
                            onEscKeyUp={() => this.setState({ isSecondContentLayerVisible: !this.state.isSecondContentLayerVisible })}
                        >
                            <Container
                                padding={ContainerPadding.static200}
                                wrap={ContainerWrap.always}
                                stretchContent={true}
                                verticalAlign={ContainerVerticalAlignment.center}
                            >
                                <Container
                                    horizontalAlign={ContainerHorizontalAlignment.spaceBetween}
                                    verticalAlign={ContainerVerticalAlignment.center}
                                    wrap={ContainerWrap.never}
                                >
                                    <Container wrap={ContainerWrap.always}>
                                        <Text></Text>
                                    </Container>
                                    <Container horizontalAlign={ContainerHorizontalAlignment.flexEnd} wrap={ContainerWrap.always}>
                                        <ActionButton
                                            icon={<Close variant={'small'} />}
                                            onClick={() => this.setState({ isSecondContentLayerVisible: !this.state.isSecondContentLayerVisible, isPopUpActionButtonVisible: !this.state.isPopUpActionButtonVisible })} />

                                    </Container>
                                </Container>
                                <Container wrap={ContainerWrap.always}>
                                    <Text appearance={TextAppearance.copy0200} bold>
                                        {modelName}<br />
                                        <span style={{ color: '#00b0f0' }}>{modelPrice} TL</span>
                                    </Text>
                                </Container>
                            </Container>
                            <Container stretchContent={true} wrap={ContainerWrap.always}
                            >
                                {this.renderContentFeatures(data)}
                            </Container>
                            <Container
                                horizontalAlign={ContainerHorizontalAlignment.center}
                                padding={{ top: ContainerPadding.dynamic0100, bottom: ContainerPadding.dynamic0100 }}
                            >
                                <ActionButton
                                    icon={<Close variant={'small'} />}
                                    onClick={() => this.setState({ isSecondContentLayerVisible: !this.state.isSecondContentLayerVisible, isPopUpActionButtonVisible: !this.state.isPopUpActionButtonVisible })}
                                >
                                    Kapat
                </ActionButton>
                            </Container>
                        </ContentLayer>
                    ]
                        : undefined
                }
            </LayerWrapper>
        )
    }


    renderThreeContentLayer(data, modelName, modelPrice) {
        const { isThreeContentLayerVisible } = this.state;
        const changeIsContentLayerVisible = () => this.setState({ isThreeContentLayerVisible: !isThreeContentLayerVisible })

        return (
            <LayerWrapper>
                {
                    isThreeContentLayerVisible ? [
                        <ShimLayer key="shim" onClick={() => changeIsContentLayerVisible()} />,
                        <ContentLayer
                            key="content-layer"
                            active={isThreeContentLayerVisible}
                            ariaLabelledBy="headline-id"
                            onEscKeyUp={() => this.setState({ isThreeContentLayerVisible: !this.state.isThreeContentLayerVisible, })}
                        >
                            <Container
                                padding={ContainerPadding.static200}
                                wrap={ContainerWrap.always}
                                stretchContent={true}
                                verticalAlign={ContainerVerticalAlignment.center}
                            >
                                <Container
                                    horizontalAlign={ContainerHorizontalAlignment.spaceBetween}
                                    verticalAlign={ContainerVerticalAlignment.center}
                                    wrap={ContainerWrap.never}
                                >
                                    <Container wrap={ContainerWrap.always}>
                                        <Text></Text>
                                    </Container>
                                    <Container horizontalAlign={ContainerHorizontalAlignment.flexEnd} wrap={ContainerWrap.always}>
                                        <ActionButton
                                            icon={<Close variant={'small'} />}
                                            onClick={() => this.setState({ isThreeContentLayerVisible: !this.state.isThreeContentLayerVisible, isPopUpActionButtonVisible: !this.state.isPopUpActionButtonVisible })} />

                                    </Container>
                                </Container>
                                <Container wrap={ContainerWrap.always}>
                                    <Text appearance={TextAppearance.copy0200} bold>
                                        {modelName}<br />
                                        <span style={{ color: '#00b0f0' }}>{modelPrice} TL</span>
                                    </Text>
                                </Container>
                            </Container>
                            <Container stretchContent={true} wrap={ContainerWrap.always}
                            >
                                {this.renderContentFeatures(data)}
                            </Container>
                            <Container
                                horizontalAlign={ContainerHorizontalAlignment.center}
                                padding={{ top: ContainerPadding.dynamic0100, bottom: ContainerPadding.dynamic0100 }}
                            >
                                <ActionButton
                                    icon={<Close variant={'small'} />}
                                    onClick={() => this.setState({ isThreeContentLayerVisible: !this.state.isThreeContentLayerVisible, isPopUpActionButtonVisible: !this.state.isPopUpActionButtonVisible })}
                                >
                                    Kapat
                </ActionButton>
                            </Container>
                        </ContentLayer>
                    ]
                        : undefined
                }
            </LayerWrapper>
        )
    }


    renderSecondPopupButton() {
        if (this.state.isPopUpActionButtonVisible) {
            return (

                <Container gutter={ContainerGutter.dynamic0050}
                    horizontalAlign={ContainerHorizontalAlignment.center}
                    padding={{ top: ContainerPadding.dynamic0100, bottom: ContainerPadding.dynamic0100 }}
                >
                    <a
                        tag="button"
                        emphasis="secondary"
                        onClick={() => this.setState({ isSecondContentLayerVisible: !this.state.isSecondContentLayerVisible, isPopUpActionButtonVisible: !this.state.isPopUpActionButtonVisible })}
                    >
                        <span style={{ color: '001e50' }}>Fiyat Detayı</span>
                    </a><ChevronDown variant={'small'} />
                </Container>
            )
        }

    }

    renderThreePopupButton() {

        if (this.state.isPopUpActionButtonVisible) {
            return (

                <Container gutter={ContainerGutter.dynamic0050}
                    horizontalAlign={ContainerHorizontalAlignment.center}
                    padding={{ top: ContainerPadding.dynamic0100, bottom: ContainerPadding.dynamic0100 }}
                >
                    <a
                        tag="button"
                        emphasis="secondary"
                        onClick={() => this.setState({ isThreeContentLayerVisible: !this.state.isThreeContentLayerVisible, isPopUpActionButtonVisible: !this.state.isPopUpActionButtonVisible })}
                    >
                        <span style={{ color: '001e50' }}>Fiyat Detayı</span>
                    </a><ChevronDown variant={'small'} />
                </Container>
            )
        }



    }

    renderCarDetailsAndPopup(props) {
        if (props.carName == 'Caddy Trendline') {
            return (
                <div style={{ marginTop: '40px' }}>
                    <Container padding={detailContainerPadding} wrap={ContainerWrap.always}>
                        {this.renderDetailSection(props.modelNameOne, props.kafone)}
                        {this.renderContentLayer(props.data, props.modelNameOne, props.kafone)}
                        {this.renderPopupButton()}
                        {this.renderDetailSection(props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondContentLayer(props.dataTwo, props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondPopupButton()}</Container>
                </div>)


        }
        else if (props.carName == 'Caddy Comfortline') {
            return (
                <div style={{ marginTop: '40px' }}>
                    <Container padding={detailContainerPadding} wrap={ContainerWrap.always}>
                        {this.renderDetailSection(props.modelNameOne, props.kafone)}
                        {this.renderContentLayer(props.data, props.modelNameOne, props.kafone)}
                        {this.renderPopupButton()}
                        {this.renderDetailSection(props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondContentLayer(props.dataTwo, props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondPopupButton()}
                    </Container>
                </div>
            )


        }
        else if (props.carName == 'Caddy Exclusive') {

            return (
                <div style={{ marginTop: '40px' }}>
                    <Container padding={detailContainerPadding} wrap={ContainerWrap.always}>
                        {this.renderDetailSection(props.modelNameOne, props.kafone)}
                        {this.renderContentLayer(props.data, props.modelNameOne, props.kafone)}
                        {this.renderPopupButton()}
                        {this.renderDetailSection(props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondContentLayer(props.dataTwo, props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondPopupButton()}
                    </Container>
                </div>
            )

        }
        else if (props.carName == 'Caddy Maxi Van') {

            return (
                <div style={{ marginTop: '40px' }}>
                    <Container padding={detailContainerPadding} wrap={ContainerWrap.always}>
                        {this.renderDetailSection(props.modelNameOne, props.kafone)}
                        {this.renderContentLayer(props.data, props.modelNameOne, props.kafone)}
                        {this.renderPopupButton()}
                        {this.renderDetailSection(props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondContentLayer(props.dataTwo, props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondPopupButton()}
                    </Container>
                </div>
            )

        }

        else if (props.carName == 'Transporter Kombi') {

            return (
                <div style={{ marginTop: '40px' }}>
                    <Container padding={detailContainerPadding} wrap={ContainerWrap.always}>
                        {this.renderDetailSection(props.modelNameOne, props.kafone)}
                        {this.renderContentLayer(props.data, props.modelNameOne, props.kafone)}
                        {this.renderPopupButton()}
                        {this.renderDetailSection(props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondContentLayer(props.dataTwo, props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondPopupButton()}
                    </Container>
                </div>
            )

        }

        else if (props.carName == 'Transporter Panel Van') {

            return (
                <div style={{ marginTop: '40px' }}>
                    <Container padding={detailContainerPadding} wrap={ContainerWrap.always}>
                        {this.renderDetailSection(props.modelNameOne, props.kafone)}
                        {this.renderContentLayer(props.data, props.modelNameOne, props.kafone)}
                        {this.renderPopupButton()}
                        {this.renderDetailSection(props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondContentLayer(props.dataTwo, props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondPopupButton()}
                        {this.renderDetailSection(props.modelNameThree, props.kafthree)}
                        {this.renderThreeContentLayer(props.dataThree, props.modelNameThree, props.kafthree)}
                        {this.renderThreePopupButton()}
                    </Container>
                </div>
            )

        }
        else if (props.carName == 'Transporter Pikap') {

            return (
                <div style={{ marginTop: '40px' }}>
                    <Container padding={detailContainerPadding} wrap={ContainerWrap.always}>
                        {this.renderDetailSection(props.modelNameOne, props.kafone)}
                        {this.renderContentLayer(props.data, props.modelNameOne, props.kafone)}
                        {this.renderPopupButton()}
                        {this.renderDetailSection(props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondContentLayer(props.dataTwo, props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondPopupButton()}
                    </Container>
                </div>
            )

        }

        else if (props.carName == 'Caravelle Comfortline') {

            return (
                <div style={{ marginTop: '40px' }}>
                    <Container padding={detailContainerPadding} wrap={ContainerWrap.always}>
                        {this.renderDetailSection(props.modelNameOne, props.kafone)}
                        {this.renderContentLayer(props.data, props.modelNameOne, props.kafone)}
                        {this.renderPopupButton()}
                        {this.renderDetailSection(props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondContentLayer(props.dataTwo, props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondPopupButton()}
                    </Container>
                </div>
            )

        }

        else if (props.carName == 'Caravelle Highline') {

            return (
                <div style={{ marginTop: '40px' }}>
                    <Container padding={detailContainerPadding} wrap={ContainerWrap.always}>
                        {this.renderDetailSection(props.modelNameOne, props.kafone)}
                        {this.renderContentLayer(props.data, props.modelNameOne, props.kafone)}
                        {this.renderPopupButton()}
                        {this.renderDetailSection(props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondContentLayer(props.dataTwo, props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondPopupButton()}
                    </Container></div>

            )

        }
        else if (props.carName == 'Amarok Highline') {

            return (
                <div style={{ marginTop: '40px' }}>
                    <Container padding={detailContainerPadding} wrap={ContainerWrap.always}>
                        <br />
                        {this.renderDetailSection(props.modelNameOne, props.kafone)}
                        {this.renderContentLayer(props.data, props.modelNameOne, props.kafone)}
                        {this.renderPopupButton()}
                    </Container></div>
            )
        }
        else if (props.carName == 'Amarok Canyon') {

            return (
                <div style={{ marginTop: '40px' }}>
                    <Container padding={detailContainerPadding} wrap={ContainerWrap.always}>
                        <br />
                        {this.renderDetailSection(props.modelNameOne, props.kafone)}
                        {this.renderContentLayer(props.data, props.modelNameOne, props.kafone)}
                        {this.renderPopupButton()}
                    </Container></div>
            )
        }
        else if (props.carName == 'Amarok Aventura') {

            return (
                <div style={{ marginTop: '40px' }}>
                    <Container padding={detailContainerPadding} wrap={ContainerWrap.always}>
                        <br />
                        {this.renderDetailSection(props.modelNameOne, props.kafone)}
                        {this.renderContentLayer(props.data, props.modelNameOne, props.kafone)}
                        {this.renderPopupButton()}
                    </Container></div>
            )
        }

        else if (props.carName == 'Crafter Servis') {

            return (
                <div style={{ marginTop: '40px' }}>
                    <Container padding={detailContainerPadding} wrap={ContainerWrap.always}>
                        {this.renderDetailSection(props.modelNameThree, props.kafthree)}
                        {this.renderContentLayer(props.dataThree, props.modelNameThree, props.kafthree)}
                        {this.renderPopupButton()}
                        {this.renderDetailSection(props.modelNameOne, props.kafone)}
                        {this.renderSecondContentLayer(props.data, props.modelNameOne, props.kafone)}
                        {this.renderSecondPopupButton()}
                        {this.renderDetailSection(props.modelNameTwo, props.kaftwo)}
                        {this.renderThreeContentLayer(props.dataTwo, props.modelNameTwo, props.kaftwo)}
                        {this.renderThreePopupButton()}
                    </Container>
                </div>
            )

        }

        else if (props.carName == 'Crafter Okul') {

            return (
                <div style={{ marginTop: '40px' }}>
                    <Container padding={detailContainerPadding} wrap={ContainerWrap.always}>
                        {this.renderDetailSection(props.modelNameThree, props.kafthree)}
                        {this.renderContentLayer(props.dataThree, props.modelNameThree, props.kafthree)}
                        {this.renderPopupButton()}
                        {this.renderDetailSection(props.modelNameOne, props.kafone)}
                        {this.renderSecondContentLayer(props.data, props.modelNameOne, props.kafone)}
                        {this.renderSecondPopupButton()}
                        {this.renderDetailSection(props.modelNameTwo, props.kaftwo)}
                        {this.renderThreeContentLayer(props.datadataTwo, props.modelNameTwo, props.kaftwo)}
                        {this.renderThreePopupButton()}
                    </Container>
                </div>
            )

        }

        else if (props.carName == 'Crafter Panel Van') {

            return (
                <div style={{ marginTop: '40px' }}>
                    <Container padding={detailContainerPadding} wrap={ContainerWrap.always}>
                        {this.renderDetailSection(props.modelNameOne, props.kafone)}
                        {this.renderContentLayer(props.data, props.modelNameOne, props.kafone)}
                        {this.renderPopupButton()}
                        {this.renderDetailSection(props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondContentLayer(props.dataTwo, props.modelNameTwo, props.kaftwo)}
                        {this.renderSecondPopupButton()}
                    </Container>
                </div>
            )

        }


    }
    render() {
        return (

            <Container stretchContent={true} wrap={ContainerWrap.always} padding={topContainerPadding} >
                <BorderContainer>
                    {this.renderColorSection(this.props.carName, this.props.containerColor)}
                    {this.renderImageSection(this.props.carImage)}
                    {this.renderCarDetailsAndPopup(this.props)}
                </BorderContainer>
            </Container>
        )
    }
}

const topContainerPadding = {
    left: { [Breakpoints.default]: ContainerPadding.grid002 },
    right: { [Breakpoints.default]: ContainerPadding.grid002 }
}

const colorContainerPadding = {
    top: ContainerPadding.dynamic0100,
    bottom: ContainerPadding.dynamic0350,
    left: ContainerPadding.dynamic0200,
    right: ContainerPadding.dynamic0100
}

const imageContainerPadding = {
    right: ContainerPadding.grid005,
    left: ContainerPadding.grid005
}

const detailContainerPadding = {
    right: ContainerPadding.grid001,
    left: ContainerPadding.grid001
}
const imageContainerPaddingTwo = {
    top: '300px'
}


export default PriceCard;